import type DrillholeDto from "../../../../../../../dto/calculations/DrillholeDto";

export const sortDrillholeDtos = <T extends {id: string}>(
  orderedUiDrillholeIds: string[],
  drillholes: T[],
): T[] => {
  const drillholesCopy = [...drillholes.map(dh => ({...dh}))];
  drillholesCopy.sort((a, b) => {
    let aIndex = orderedUiDrillholeIds.indexOf(a.id);
    let bIndex = orderedUiDrillholeIds.indexOf(b.id);
    if (aIndex === -1) aIndex = Number.MAX_VALUE;
    if (bIndex === -1) bIndex = Number.MAX_VALUE;
    return aIndex - bIndex;
  });
  return drillholesCopy;
};

export const computeDrillholesValue = (drillholes: DrillholeDto[]): string =>
  drillholes.map(dh => dh.symbol + (dh.number ?? "")).join("");